import { FC } from 'react'
import { Table } from '@tanstack/react-table'

import { TableHeaderGroup } from '../table-header-group'

type TableHeaderProps = {
  tableInstance: Table<any>
  isRowsDraggable?: boolean
  isFlex?: boolean
  hasExpandableRows?: boolean
}

const TableHeader: FC<TableHeaderProps> = props => {
  const { tableInstance, isRowsDraggable, isFlex, hasExpandableRows } = props;

  return (
    <thead style={{ position: 'sticky', top: 0, backgroundColor: 'white' }}>
      {tableInstance.getHeaderGroups().map((headerGroup, index) => (
        <TableHeaderGroup
          key={index}
          headerGroup={headerGroup}
          isRowsDraggable={isRowsDraggable}
          isFlex={isFlex}
          hasExpandableRows={hasExpandableRows}
        />
      ))}
    </thead>
  );
}

export default TableHeader
